//Account
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";

// Language Selection
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";

// DataLists
export const LOAD_STATES_SUCCESS = "LOAD_STATES_SUCCESS";
export const LOAD_COUNTRIES_SUCCESS = "LOAD_COUNTRIES_SUCCESS";
export const LOAD_PROGRAM_TYPES_SUCCESS = "LOAD_PROGRAM_TYPES_SUCCESS";

//Dashboard
export const LOAD_NEXT_PAYMENT_SUCCESS = "LOAD_NEXT_PAYMENT_SUCCESS";
export const LOAD_DEVICES_SUCCESS = "LOAD_DEVICES_SUCCESS";

//Notifications
export const LOAD_NOTIFICATIONS_SUCCESS = "LOAD_NOTIFICATIONS_SUCCESS";
export const SAVE_NOTIFICATIONS_OPTIMISTIC = "SAVE_NOTIFICATIONS_OPTIMISTIC";
export const DELETE_NOTIFICATIONS_OPTIMISTIC =
  "DELETE_NOTIFICATIONS_OPTIMISTIC";
export const DELETE_NOTIFICATIONS_LAST_OPTIMISTIC =
  "DELETE_NOTIFICATIONS_LAST_OPTIMISTIC";

//Profile
export const LOAD_PROFILE_SUCCESS = "LOAD_PROFILE_SUCCESS";
export const SAVE_PROFILE_SUCCESS = "SAVE_PROFILE_SUCCESS";
export const UPDATE_COPY_PROFILE_SUCCESS = "UPDATE_COPY_PROFILE_SUCCESS";
export const LOAD_VEHICLE_SUCCESS = "LOAD_VEHICLE_SUCCESS";
export const SAVE_VEHICLE_SUCCESS = "SAVE_VEHICLE_SUCCESS";
export const UPDATE_VEHICLE_SUCCESS = "UPDATE_VEHICLE_SUCCESS";
export const ADD_VEHICLE_SUCCESS = "ADD_VEHICLE_SUCCESS";
export const ENROLLEE_LOAD_SUCCESS = "ENROLLEE_LOAD_SUCCESS";
export const ENROLLEE_UPDATE_SUCCESS = "ENROLLEE_UPDATE_SUCCESS";
export const CLIENT_UPDATE_SUCCESS = "CLIENT_UPDATE_SUCCESS";
export const ENROLLEE_SCHEDULE_SUCCESS = "ENROLLEE_SCHEDULE_SUCCESS";
export const IS_CLICK_AND_GO_CLIENT_SUCCESS = "IS_CLICK_AND_GO_CLIENT_SUCCESS";

//Appointments
export const LOAD_APPOINTMENTS_SUCCESS = "LOAD_APPOINTMENTS_SUCCESS";
export const SAVE_APPOINTMENT_OPTIMISTIC = "SAVE_APPOINTMENT_OPTIMISTIC";
export const DELETE_APPOINTMENT_OPTIMISTIC = "DELETE_APPOINTMENT_OPTIMISTIC";
export const DELETE_APPOINTMENT_LAST_OPTIMISTIC =
  "DELETE_APPOINTMENT_LAST_OPTIMISTIC";
export const CREATE_APPOINTMENT_SUCCESS = "CREATE_APPOINTMENT_SUCCESS";
export const LOAD_LOCATIONS_SUCCESS = "LOAD_LOCATIONS_SUCCESS";
export const LOAD_AVAILABLE_DATES_SUCCESS = "LOAD_AVAILABLE_DATES_SUCCESS";
export const LOAD_AVAILABLE_HOURS_SUCCESS = "LOAD_AVAILABLE_HOURS_SUCCESS";
export const RESET_LOCATIONS_SUCCESS = "RESET_LOCATIONS_SUCCESS";
export const RESET_AVAILABLE_DATES_SUCCESS = "RESET_AVAILABLE_DATES_SUCCESS";
export const RESET_AVAILABLE_HOURS_SUCCESS = "RESET_AVAILABLE_HOURS_SUCCESS";
export const RESET_APPOINTMENTS_SUCCESS = "RESET_APPOINTMENTS_SUCCESS";
export const LOAD_AVAILABLE_SERVICES_SUCCESS =
  "LOAD_AVAILABLE_SERVICES_SUCCESS";
export const RESET_AVAILABLE_SERVICES_SUCCESS =
  "RESET_AVAILABLE_SERVICES_SUCCESS";

//Payments
export const LOAD_ACCOUNT_HISTORY_SUCCESS = "LOAD_ACCOUNT_HISTORY_SUCCESS";
export const UNLOAD_ACCOUNT_HISTORY_SUCCESS = "UNLOAD_ACCOUNT_HISTORY_SUCCESS";
export const CREATE_PAYMENT_SUCCESS = "CREATE_PAYMENT_SUCCESS";
export const LOAD_INVOICE_SUCCESS = "LOAD_INVOICE_SUCCESS";
export const RESET_INVOICE_SUCCESS = "RESET_INVOICE_SUCCESS";
export const LOAD_PAYMENT_METHOD_SUCCESS = "LOAD_PAYMENT_METHOD_SUCCESS";
export const SAVE_PAYMENT_METHOD_OPTIMISTIC = "SAVE_PAYMENT_METHOD_OPTIMISTIC";
export const DELETE_PAYMENT_METHOD_OPTIMISTIC =
  "DELETE_PAYMENT_METHOD_OPTIMISTIC";
export const DELETE_PAYMENT_METHOD_LAST_OPTIMISTIC =
  "DELETE_PAYMENT_METHOD_LAST_OPTIMISTIC";
export const CREATE_PAYMENT_METHOD_SUCCESS = "CREATE_PAYMENT_METHOD_SUCCESS";

//Documents
export const LOAD_DOCUMENTS_SUCCESS = "LOAD_DOCUMENTS_SUCCESS";
export const LOAD_TODO_LIST_SUCCESS = "LOAD_TODO_LIST_SUCCESS";
export const LOAD_COMPLETED_LIST_SUCCESS = "LOAD_COMPLETED_LIST_SUCCESS";
export const LOAD_COMPLETED_DOCUMENT_SUCCESS =
  "LOAD_COMPLETED_DOCUMENT_SUCCESS";
export const LOAD_REPORTSIGNATURES_SUCCESS = "LOAD_REPORTSIGNATURES_SUCCESS";
export const SAVE_REPORTSIGNATURE_OPTIMISTIC = "SAVE_REPORTSIGNATURE_SUCCESS";
export const UPLOAD_DOCUMENT_SUCCESS = "UPLOAD_DOCUMENT_SUCCESS";
export const RESET_COMPLETED_DOCUMENT_SUCCESS =
  "RESET_COMPLETED_DOCUMENT_SUCCESS";
export const LOAD_REPORT_SUCCESS = "LOAD_REPORT_SUCCESS";
export const UNLOAD_REPORT_SUCCESS = "UNLOAD_REPORT_SUCCESS";
export const SAVE_COMPLETED_REPORT_OPTIMISTIC =
  "SAVE_COMPLETED_REPORT_OPTIMISTIC";

export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";
